import React, { useState } from "react";
import { Box, Typography, Button, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SendIcon from "@material-ui/icons/Send";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: "-50%",
      right: "-10%",
      width: "500px",
      height: "500px",
      background: "rgba(255, 255, 255, 0.1)",
      borderRadius: "50%",
      animation: "$float 6s ease-in-out infinite",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "-30%",
      left: "-5%",
      width: "400px",
      height: "400px",
      background: "rgba(255, 255, 255, 0.05)",
      borderRadius: "50%",
      animation: "$float 8s ease-in-out infinite reverse",
    },
  },
  "@keyframes float": {
    "0%, 100%": {
      transform: "translateY(0px)",
    },
    "50%": {
      transform: "translateY(30px)",
    },
  },
  container: {
    maxWidth: "550px",
    width: "100%",
    zIndex: 10,
  },
  card: {
    borderRadius: "16px",
    // boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
    padding: theme.spacing(4),
    background: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
  },
  header: {
    textAlign: "center",
    marginBottom: theme.spacing(3),
  },
  iconContainer: {
    width: 70,
    height: 70,
    borderRadius: "14px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    marginBottom: theme.spacing(1.5),
  },
  title: {
    fontSize: "2.2rem",
    fontWeight: 700,
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    marginBottom: theme.spacing(0.5),
    fontFamily: "'Poppins', sans-serif",
  },
  subtitle: {
    fontSize: "0.95rem",
    color: "#666",
    fontFamily: "'Poppins', sans-serif",
  },
  detailsSection: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(3),
    background: "#f8f9fa",
    borderRadius: "12px",
    border: "1px solid #e0e0e0",
    textAlign: "center",
  },
  detailItem: {
    marginBottom: theme.spacing(2.5),
    "&:last-child": {
      marginBottom: 0,
    },
  },
  detailLabel: {
    fontSize: "0.85rem",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "1.2px",
    color: "#764ba2",
    marginBottom: theme.spacing(0.5),
    fontFamily: "'Poppins', sans-serif",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
  },
  detailText: {
    fontSize: "1.05rem",
    color: "#333",
    fontWeight: 500,
    lineHeight: 1.6,
    fontFamily: "'Poppins', sans-serif",
    wordBreak: "break-word",
    cursor: "pointer",
    transition: "all 0.3s ease",
    padding: theme.spacing(1),
    borderRadius: "8px",
    "&:hover": {
      color: "#667eea",
      backgroundColor: "rgba(102, 126, 234, 0.1)",
      transform: "scale(1.02)",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  createButton: {
    // background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    background: "linear-gradient(135deg, #1e243c 0%, #003a6b 100%)",

    color: "white",
    fontWeight: 600,
    textTransform: "none",
    fontSize: "1.1rem",
    padding: theme.spacing(1.5, 3),
    borderRadius: "10px",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    fontFamily: "'Poppins', sans-serif",
    border: "none",
    cursor: "pointer",
    boxShadow: "0 6px 20px rgba(102, 126, 234, 0.4)",
    "&:hover": {
      transform: "translateY(-3px)",
      boxShadow: "0 10px 30px rgba(102, 126, 234, 0.6)",
    },
    "&:active": {
      transform: "translateY(0px)",
    },
  },
  supportInfo: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    background:
      "linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%)",
    borderRadius: "10px",
    border: "1px solid rgba(102, 126, 234, 0.2)",
    textAlign: "center",
  },
  supportText: {
    fontSize: "0.9rem",
    color: "#666",
    fontFamily: "'Poppins', sans-serif",
    lineHeight: 1.5,
  },
}));

function CreateTickets() {
  const classes = useStyles();
  const [activeContact, setActiveContact] = useState(null);

  // Get user data from session storage
  const permissionAccess = JSON.parse(sessionStorage.getItem("data")) || {};
  const name = permissionAccess?.name || "Not provided";
  const email = permissionAccess?.email;
  const mobileNumber = permissionAccess?.company?.number || "Not provided";

  const handleCreateTicket = () => {
    const Url = `http://support.watsoo.com/sso?companyToken=${encodeURIComponent(
      "MCL"
    )}&username=${encodeURIComponent(
      email
    )}`;
    window.open(Url, "_blank");
  };

  const handleEmailClick = () => {
    setActiveContact("email");
    setTimeout(() => {
      window.open(`mailto:${"mclsupport@watsoo.com"}`, "_blank");
    }, 300);
  };

  const handlePhoneClick = () => {
    setActiveContact("phone");
    setTimeout(() => {
      window.open(`tel:${mobileNumber}`, "_blank");
    }, 300);
  };

  return (
    <Box>
      <Box>
        <Card className={classes.card} elevation={0}>
          {/* Header with Button */}
          <Box className={classes.header}>
            <Box className={classes.buttonContainer}>
              <Button
                className={classes.createButton}
                startIcon={<SendIcon />}
                onClick={handleCreateTicket}
              >
                Create Ticket Now
              </Button>
            </Box>
          </Box>

          {/* User Details Section - Centered */}
          <Box className={classes.detailsSection}>
            {/* Email Detail */}
            <Box className={classes.detailItem}>
              <Typography className={classes.detailLabel}>
                <EmailIcon style={{ fontSize: "25px" }} />
                Email Address
              </Typography>
              <Typography
                className={classes.detailText}
                //
                style={{
                  backgroundColor:
                    activeContact === "email"
                      ? "rgba(102, 126, 234, 0.2)"
                      : "transparent",
                      fontWeight:"bold"
                }}
              >
                <span onClick={handleEmailClick}>
                  {"mclsupport@watsoo.com"}
                </span>
              </Typography>
              {/* <Typography
                style={{
                  fontSize: "0.8rem",
                  color: "#999",
                  marginTop: "4px",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                Click to send email
              </Typography> */}
            </Box>

            {/* Phone Detail */}
            {/* <Box className={classes.detailItem}>
              <Typography className={classes.detailLabel}>
                <PhoneIcon style={{ fontSize: "20px" }} />
                Phone Number
              </Typography>
              <Typography
                className={classes.detailText}
                onClick={handlePhoneClick}
                style={{
                  backgroundColor:
                    activeContact === "phone"
                      ? "rgba(118, 75, 162, 0.2)"
                      : "transparent",
                }}
              >
                {mobileNumber}
              </Typography>
            </Box> */}
          </Box>

          {/* Support Info */}
          {/* <Box className={classes.supportInfo}>
            <Typography className={classes.supportText}>
              ⏱️ Average response time: 2-4 hours
              <br />
              🕐 Business hours: Mon-Fri, 9 AM - 6 PM
            </Typography>
          </Box> */}
        </Card>
      </Box>
    </Box>
  );
}

export default CreateTickets;
